<div class="event-checkout-dialog" *ngIf="userInfo" [style.background-color]="settingsData?.event_bg_main_color + '!important'" 
[style.color]="settingsData?.event_font_main_color + '!important'">
    <div class="modal-body text-center" [ngClass]="{'w-330':deviceInfo =='web'}">
        <h1 class="fs-30 ff fw-500">Thank You!</h1>
        <!-- <p class="fs-18 fw-400 modal-text">Confirmation email sent to "{{userInfo.email}}"</p> -->
        <p class="fs-18 fw-400 modal-text" *ngIf="data.streamInfo!=undefined">Confirmation email sent.</p>
        <ng-container *ngIf="deviceInfo =='android'">
            <h5 class="text-center pt-5 fs-16 text-white">
                Please download <span class="text-capitalize">{{clientDetails.slug}}</span>'s app from Play Store to watch the stream on mobile.</h5>
            <div class="text-center mt-20">
                <a href="https://play.google.com/store/apps/details?id=com.arevea.tv"><img
                        [src]="assets_url + 'website/homepage/googleplay.png'" class="store-img"></a>
            </div>
        </ng-container>
        <ng-container *ngIf="deviceInfo =='ios'">
            <h5 class="text-center pt-5 fs-16 text-white">Please download <span class="text-capitalize">{{clientDetails.slug}}</span>'s app from App Store to watch the
                stream on mobile.</h5>
            <div class="text-center mt-20">
                <a href="https://apps.apple.com/in/app/arevea/id1535047464"><img
                        [src]="assets_url + 'website/homepage/appstore.png'" class="store-img"></a>
            </div>
        </ng-container>
        <ng-container *ngIf="deviceInfo =='web'">
            <div class="row justify-content-center">
                <button class="flat-primary-dark mt-2 mr-20 mb-10" *ngIf="!vodUrl" (click)="goToHome()"
                [ngStyle]="{'background-color':settingsData?.event_button_bg_primary_color , 'color':settingsData?.event_button_font_primary_color}">Go to Home</button>
                <button class="flat-primary-dark mt-2 mr-20 mb-10" *ngIf="vodUrl" (click)="goToChannelVod()"  [ngStyle]="{'background-color':settingsData?.event_button_bg_primary_color , 'color':settingsData?.event_button_font_primary_color}">
                    Go to VOD</button>
                <!-- <ng-container *ngIf="!addOnCheck">
                    <button class="flat-primary-dark mt-2 mb-10" (click)="goToSchedule()"
                        *ngIf="ticket_key !='' && ticket_key != undefined && (!showExpo && !showNetworking && showSchedule)">Go
                        to <span *ngIf="subEvents && subEvents.length > 1 || !showStream">Schedule</span><span
                            *ngIf="(subEvents && subEvents.length == 1 && subEvents[0]?.stream_status != 'completed') && showStream">Stream</span>
                        <span
                            *ngIf="subEvents && subEvents.length == 1 && (subEvents[0].stream_status == 'completed' && subEvents[0].conversion_status == 'completed')">VOD</span></button>
                    <div [hidden]="showExpo && showNetworking">
                        <button class="flat-primary-dark mt-2 mr-20 mb-10"
                            *ngIf="showExpo && ticket_key !='' && ticket_key != undefined" (click)="goToExpo()">Go to
                            Expo</button>
                        <button class="flat-primary-dark mt-2 mr-20 mb-10"
                            *ngIf="showNetworking && ticket_key !='' && ticket_key != undefined"
                            (click)="goToNetworking()">Go to Networking</button>
                    </div>
                    <button class="flat-primary-dark mt-2 mr-20 mb-10"
                        *ngIf="showExpo && showNetworking && ticket_key !='' && ticket_key != undefined"
                        (click)="goToExpo()">Go to Expo</button>
                </ng-container> -->
            </div>
            <!-- <button class="flat-primary-dark mt-2" *ngIf="eventType != 'vod' && streamInfo.stream_status != 'completed'"
                (click)="goToStream()">Go to Stream</button>
            <button class="flat-primary-dark mt-2" *ngIf="eventType == 'vod' || streamInfo.stream_status == 'completed'"
                (click)="goToVOD()">Go to VOD</button> -->
        </ng-container>
    </div>
</div>